import { styled } from '@mui/material/styles';

import checkIcon from 'assets/svg/CheckIcon.svg';
import checkSmallIcon from 'assets/svg/Check_small.svg';
import dash from 'assets/svg/dash.svg';
import dashSmall from 'assets/svg/dash_small.svg';

import color from 'atoms/colors/colors';

declare module '@mui/material/Checkbox' {
  interface CheckboxPropsSizeOverrides {
    large: true;
    medium: false;
  }
}

export const CheckIcon = styled('span', {
  shouldForwardProp: prop => prop !== 'size',
})<{ size: 'small' | 'large' | undefined }>(({ size }) => ({
  width: size === 'small' ? 16 : 20,
  height: size === 'small' ? 16 : 20,
  borderRadius: 4,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: color.wave[800],
  display: 'inline-block',
  position: 'relative',
  transition: 'all .3s',
  boxShadow: '0px 0px 0px 0px #F4EBFF',
  'input:not([disabled]):hover ~ &': {
    backgroundColor: color.storm[100],
  },
  'input:focus ~ &': {
    boxShadow: '0px 0px 0px 4px #F4EBFF',
  },
  'input[disabled] ~ &': {
    opacity: 0.6,
  },
}));

export const CheckedIcon = styled(CheckIcon, {
  shouldForwardProp: prop => prop !== 'size',
})<{ size: 'small' | 'large' | undefined }>(({ size }) => ({
  backgroundImage: `url(${size === 'small' ? checkSmallIcon : checkIcon})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundColor: color.storm[50],
}));

export const IndeterminateIcon = styled(CheckIcon, {
  shouldForwardProp: prop => prop !== 'size',
})<{ size: 'small' | 'large' | undefined }>(({ size }) => ({
  backgroundImage: `url(${size === 'small' ? dashSmall : dash})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundColor: color.storm[50],
}));

export const darkCheckbox = {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: color.storm[300],
        // ...checkboxRoot,
        '&:hover': {
          backgroundColor: color.cloud[700],
          color: color.storm[700],
          // ...checkboxRootSvg,
          borderRadius: '4px',
        },
        '&.Mui-checked': {
          color: color.storm[600],
        },
      },
    },
    // ...checkboxVariants,
  },
};

export const lightCheckbox = {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: color.cloud[300],
        // ...checkboxRoot,
        '&:hover': {
          backgroundColor: color.storm[50],
          color: color.storm[600],
          borderRadius: '4px',
        },
        '&.Mui-checked': {
          color: color.storm[600],
        },
        // ...checkboxRootSvg,
      },
    },
    // ...checkboxVariants,
  },
};
